export default {
	projectGroupProjectsDisplay: [
		{
			id: 'name',
			label: 'Projet',
			tooltip: null
		},
		{
			id: 'budgetUsed',
			label: 'Montant payé',
			cellType: 'money',
			tooltip: 'Montant total versé par rapport au budget alloué au groupement sans prise en compte des indus'
		},
		{
			id: 'undueBalance',
			label: 'Indus',
			cellType: 'money',
			tooltip: null
		},
		{
			id: 'totalUndueAmountRefunded',
			label: 'Montant total remboursé',
			cellType: 'money',
			tooltip: null
		},
		{
			id: 'endDate',
			label: 'Date de fin d\'autorisation de facturation',
			cellType: 'date',
			tooltip: null
		},
		{
			id: 'patientUsed',
			label: 'Nombre de patients',
			tooltip: null
		}
	],
	projectGroupCardDisplay: {
		allocatedBudgetText: 'Budget alloué',
		budgetConsumptionText: 'Conso budget',
		undueBalanceText: 'Solde Indus',
		totalUndueAmountRefundedText: 'Montant total remboursé groupement',
		budgetUsedText: 'Montant payé sans indus',
		patientCountText: 'Nombre de patients cible',
		patientRationText: 'Conso patient'
	},
	closeButton: 'Fermer'
};
